import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
  text: {
    color: theme.palette.grey[200],
    fontWeight: 600,
  },
}))

export default useStyles
